import { gql } from '@apollo/client';
import { AddShareItemsInput } from 'types/Share';

const addItemsAndSubmit = (shareUri: string, input: AddShareItemsInput[]) => {
    return {
        variables: {
            shareUri,
            input,
        },
        mutation: gql`
            mutation AddBatchSharedItemsAndSubmitRequest(
                $shareUri: String
                $input: [AddSharedItemInput]
            ) {
                addBatchSharedItemsAndSubmitRequest(
                    shareUri: $shareUri
                    input: $input
                ) {
                    shareUri
                }
            }
        `,
    };
};

export default addItemsAndSubmit;
